import { Game } from "../../../game.js";
import { ImgID } from "../../../image_loader/img_id.js";
import { UIImage } from "../../common_ui_elements/ui_image.js";
import { UINineSliceElement } from "../../common_ui_elements/ui_nine_slice_element.js";
import { ShopScreen } from "../../screens/shop_screen/shop_screen.js";
import { SafeAreas } from "../../safe_areas.js";
import { AbstractOverlay } from "../abstract_overlay.js";
import { OverlayId } from "../overlay_ids.js";
import { OverlayManager } from "../overlay_manager.js";

export class ShopOverlay extends AbstractOverlay
{
  private static readonly BOTTOM_BAR_DESIGN_H = 400;
  /** Orange line inside navigation_bg's 200px top cap (see NavigationBlock.NAV_BG_LINE_SOURCE_Y). */
  private static readonly BOTTOM_BAR_LINE_DESIGN_Y = 128.5;

  private readonly shop: ShopScreen;
  private closed = false;
  constructor(
    ctx: CanvasRenderingContext2D,
    x: number,
    y: number,
    width: number,
    height: number,
    params: any,
    overlay_id: OverlayId
  )
  {
    super( ctx, x, y, width, height, overlay_id, params, false );

    this.shop = new ShopScreen( ctx, 0, 0, width, height, false );
    this.shop.render_top_safe_area = false;
    this.addChild( this.shop );

    this.shop.onCoinsPurchased = () =>
    {
      OverlayManager.closeOverlay();
    }

    this.createBottomBar();
    this.createCloseIcon();
  }

  public onOverlayWillClose(): void
  {
    if ( this.closed ) return;
    this.closed = true;
    this.shop.destroy();
    this.params?.onShopClosed?.();
  }

  private createBottomBar(): void
  {
    const bar_h = LayoutScaler.heightFromDesign( ShopOverlay.BOTTOM_BAR_DESIGN_H );
    const bar = new UINineSliceElement(
      this.ctx,
      0,
      this.rect.getH() - bar_h,
      this.rect.getW(),
      bar_h + Game.safeAreaBottom(),
      ImgID.UI_NavigationBg,
      "navigation_bg"
    );

    this.addChild( bar );
  }

  private createCloseIcon(): void
  {
    const w = LayoutScaler.widthFromDesign( 130 );
    const h = LayoutScaler.heightFromDesign( 130 );
    const bar_h = LayoutScaler.heightFromDesign( ShopOverlay.BOTTOM_BAR_DESIGN_H );
    // The top cap of navigation_bg is mostly transparent: the visible blue
    // starts at its orange line and runs to the physical bottom of the screen
    // (the bar is stretched over the bottom inset). Centre in that blue.
    const blue_top = this.rect.getH() - bar_h + LayoutScaler.heightFromDesign( ShopOverlay.BOTTOM_BAR_LINE_DESIGN_Y );
    const blue_bottom = this.rect.getH() + Game.safeAreaBottom();
    const x = this.rect.getW2() - w / 2;
    const y = ( blue_top + blue_bottom ) / 2 - h / 2;

    const close = new UIImage(
      this.ctx,
      x,
      y,
      w,
      h,
      ImgID.UI_SettingsDialogCloseBtn,
      {},
      true
    )

    close.setOnClick( () => OverlayManager.closeOverlay() );

    this.addChild( close );
  }

  public name(): string
  {
    return "ShopOverlay";
  }

  public override getViewportBackground(): string
  {
    return "#0039B9";
  }

  public render(): void
  {
    if ( !this.shouldBeRendered() )
      return;

    this.startRender();
    this.finishRender();

    // Same untranslated ctx as the menu's ShopScreen, so the strip lands on
    // the real top inset instead of one inset lower.
    SafeAreas.renderTopSafeAreaOverlay( this.ctx );
  }
}
